// extracted by mini-css-extract-plugin
export default {"wrapper":"BannedView_wrapper__j4tWG","header":"BannedView_header__5KFod"};